import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

//UI
import ShowPassword from '../../../components/Inputs/ShowPassword';
import logo from '../../../assets/peef.png';
import UserLogo from '../../../components/Inputs/UserLogo';
//SLICE
import { initialStateParent, createParentAccount } from '../../../store/slices/public/parents.slice';
import { API_BASE_URL } from '../../../store/constans';
import MainLoader from '../../../components/Loaders/MainLoader';
import { getConfigsThunk, initialStateConfig } from '../../../store/slices/catalogs/config.slice';

const CreateAccountPublic = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { getValues, register, handleSubmit, formState: { errors } } = useForm();
  const [isPasswordConfirmHidden, setIsPasswordConfirmHidden] = useState(true);
  const [isPasswordHidden, setIsPasswordHidden] = useState(true);
  const [comparePass, setComparePass] = useState(true)
  const userState = useSelector(state => state.parents)
  const { items } = useSelector(state => state.configurations);
  const isLoading = useSelector(state => state.isLoadingSlice);

  useEffect(() => {
    dispatch(getConfigsThunk());
    return () => {
      dispatch(initialStateConfig())
      dispatch(initialStateParent());
    }
  }, []);

  const submit = (data) => {
    if (data.password === data.confirmPassword) {
      dispatch(createParentAccount(data.ciParent, data));
    }
  }

  function comparePassword(event) {
    const confirmPass = event.target.value
    if (getValues("password") !== confirmPass) {
      setComparePass(false)
    } else {
      setComparePass(true)
    }
  }

  return (
    <>
      {isLoading ? (<MainLoader />) : (
        <div
          className={`text-gray-600 flex justify-center items-center 2xl:items-center h-full w-full min-h-screen bg-cover bg-center`}
          style={{ backgroundImage: `url(${API_BASE_URL + items[0]?.background})` }}
        >
          <div className="absolute top-0 left-0 w-full h-full bg-zinc-800/40 "></div>
          <div className="w-full md:w-[35%] bg-white/80 backdrop-blur-sm shadow-md shadow-gray-800 flex flex-col items-center justify-center rounded-md z-10">
            <div className='flex flex-col gap-2 w-full items-center justify-center p-4'>
              <img className='w-[280px] md:w-[180px]' src={API_BASE_URL + items[0]?.logo} alt="logo" />
            </div>
            {userState.error &&
              <div className='flex text-start flex-col p-2 gap-1 text-sm font-sans w-[80%] border-red-500 rounded-md border mt-6 bg-red-200 items-center my-3'>
                <h1 className="mb-0 font-bold">¡Error!</h1>
                <p className='mb-0'>{userState.error}</p>
              </div>
            }

            {userState.message === "password updated successfully" ?
              <>
                <div className='flex font-sans flex-col p-2 w-[85%]  border-sky-500 text-sky-800 rounded-md border bg-sky-200 text-md my-5'>
                  <h1 className="text-left mb-0">¡Registro exitoso!</h1>
                  <p className='text-left mb-0 text-[13px]'>
                    Gracias por registrarte en nuestro sistema de matriculacion en línea.
                    Por favor revisa la bandeja de entrada o la carpeta de correo no deseado de tu correo electrónico ({userState.item}) para activar tu cuenta.
                  </p>
                </div>
                <div className='flex gap-2 w-full p-5 justify-center'>
                  <Link to={'/'} className="btn shadow-lg btn-block bg-sky-700 hover:bg-sky-800 hover:duration-75 border-none rounded-md  text-white">
                    <p className='flex items-center gap-1'>
                      Iniciar sesión
                    </p>
                  </Link>
                </div>
              </>
              :
              <>
                <div className='flex font-sans flex-col p-2 w-[85%]  border-sky-500 text-sky-800 rounded-md border bg-sky-200 text-md'>
                  <h1 className="mb-0 text-sky-700">Crear mi cuenta</h1>
                  <h1 className="mb-0 text-gray-700 text-start">Por favor crear su cuenta con la Cédula, RUC o Pasaporte del representante legal</h1>
                </div>
                <form onSubmit={handleSubmit(submit)} className="w-[75%] mx-auto text-gray-600 my-5 font-sans">
                  <div className='flex flex-col'>
                    <div className="relative flex flex-col mt-8">
                      <input className={'w-full placeholder-gray-600 p-2 rounded-xl focus:outline-none peer bg-transparent shadow-[inset_0_-1px_0_0_rgba(29,34,43,.2)]'}
                        type='text'
                        {...register("ciParent", { required: true })}
                        placeholder="Cédula / Pasaporte / RUC"
                      />
                      <UserLogo />
                    </div>
                    {errors.ciParent && (<span className="error_message">{"Información requerida"}</span>)}
                    <div className="relative flex flex-col mt-8">
                      <input className='w-full p-2 rounded-xl placeholder-gray-600 focus:outline-none peer bg-transparent shadow-[inset_0_-1px_0_0_rgba(29,34,43,.2)]'
                        type={isPasswordHidden ? 'password' : 'text'}
                        {...register("password", { required: true })}
                        placeholder="Contraseña"
                      />
                      <ShowPassword
                        isPasswordHidden={isPasswordHidden}
                        setIsPasswordHidden={setIsPasswordHidden}
                      />
                    </div>
                    {errors.password && errors.password.type === "required" && <span className="text-red-600 text-xs pl-2">{t("required_information")}</span>}
                    <div className="relative flex flex-col mt-8">
                      <input className={'w-full placeholder-gray-600 p-2 rounded-xl focus:outline-none peer bg-transparent shadow-[inset_0_-1px_0_0_rgba(29,34,43,.2)]'}
                        type={isPasswordConfirmHidden ? 'password' : 'text'}
                        {...register("confirmPassword", { required: true })}
                        placeholder="Confirme contraseña"
                        onChange={comparePassword}
                      />
                      <ShowPassword
                        isPasswordHidden={isPasswordConfirmHidden}
                        setIsPasswordHidden={setIsPasswordConfirmHidden}
                      />
                    </div>
                    {errors.confirmPassword && errors.confirmPassword.type === "required" && <span className="text-red-600 text-xs pl-2">{t("required_information")}</span>}
                    {!comparePass && <span className="text-red-600 text-xs pl-2">{t("change_password_passwords_donot_match")}</span>}
                  </div>
                  {
                    userState.procesing ?
                      <div className='flex text-sky-700 flex-col items-center justify-center text-md'>
                        <span className="loading loading-ring loading-lg"></span>
                        <h1>Procesando...</h1>
                      </div> :
                      <div className='flex w-full justify-center h-[35px] mt-10 gap-2'>
                        <Link to={'/'} type="button" className="btn shadow-lg bg-gray-400 hover:bg-gray-500 hover:duration-75 border-none rounded-md  text-white">
                          Cancelar
                        </Link>
                        <button type=" submit" className="btn shadow-lg bg-sky-700 hover:bg-sky-800 hover:duration-75 border-none rounded-md  text-white">
                          Crear cuenta
                        </button>
                      </div>
                  }
                </form>
              </>
            }
          </div>
          <div className="hidden md:flex md:flex-col md:absolute bg-white/80  md:left-[90%] md:top-[80%] z-10 p-2 rounded-md shadow-md shadow-gray-500">
            <img className='w-[280px] md:w-[100px]' src={logo} alt="logo" />
            <p className='font-semibold text-[13px]'>Proveedor Oficial</p>
          </div>
        </div >
      )}
    </>
  );
}
export default CreateAccountPublic;